import { useCurrentUser } from 'utils/hooks/useCurrentUser'

export const useShowCategoriesTree = () => {
  const user = useCurrentUser()
  return !!user?.show_categories_tree
}
